/* tslint:disable */
/* eslint-disable */
/**
 * Stututu API
 * REST API for the Stututu car community.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ShowActivity200ResponseData } from './ShowActivity200ResponseData';
import {
    ShowActivity200ResponseDataFromJSON,
    ShowActivity200ResponseDataFromJSONTyped,
    ShowActivity200ResponseDataToJSON,
    ShowActivity200ResponseDataToJSONTyped,
} from './ShowActivity200ResponseData';

/**
 * 
 * @export
 * @interface ShowActivity200Response
 */
export interface ShowActivity200Response {
    /**
     * 
     * @type {ShowActivity200ResponseData}
     * @memberof ShowActivity200Response
     */
    data?: ShowActivity200ResponseData;
}

/**
 * Check if a given object implements the ShowActivity200Response interface.
 */
export function instanceOfShowActivity200Response(value: object): value is ShowActivity200Response {
    return true;
}

export function ShowActivity200ResponseFromJSON(json: any): ShowActivity200Response {
    return ShowActivity200ResponseFromJSONTyped(json, false);
}

export function ShowActivity200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShowActivity200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ShowActivity200ResponseDataFromJSON(json['data']),
    };
}

export function ShowActivity200ResponseToJSON(json: any): ShowActivity200Response {
    return ShowActivity200ResponseToJSONTyped(json, false);
}

export function ShowActivity200ResponseToJSONTyped(value?: ShowActivity200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ShowActivity200ResponseDataToJSON(value['data']),
    };
}

